export const UserHasPermission = (actionId) => {
    return (window.optima?.user?.ActionIDs?.includes(actionId)) || (window.SelfieSettings?.settings?.user?.actions[actionId] === actionId)
}

export const PermissionsActions = {
    AllowSetFolioAsPending: 202,
    EditReceiptPrice: 189,
    AccessToCharge: 188,
    AccessToIssueInvoice: 187,
    AccessToSendConfirmation: 185,
    AccessSendEmailPage: 184,
    AccessMessagingPage: 183,
    EditReservationColor: 182,
    ViewFamilyAndFriends: 181,
    AccessSaveCardAuthorization: 180,
    CancelReservation: 179,
    CheckOutReservation: 178,
    CheckInReservation: 177,
    ViewShortReservation: 176,
    EditETA_ETD: 175,
    EditPricingType: 174,
    EditPrice: 173,
    SelectOnlyUnrestrictedProduct: 172,
    ViewRoomPlannedMaintenancePopup: 164,
    AccessPricesPopup: 163,
    AccessRestrictionsPopup: 162,
    ViewGuestInHouse: 161,
    ViewGroupReservation: 160,
    ViewReservation: 159,
    SearchReservations: 158,
    PaymentPerformRefund: 151,
    ViewAvailabilitySearch: 228,
    EditMaxPax: 229,
}